// extracted by mini-css-extract-plugin
export var collapsesibleIcon = "ExpandCollapse-module--collapsesibleIcon--3tYpi";
export var expandTitle = "ExpandCollapse-module--expandTitle--82ab3";
export var expandTitleFullWidth = "ExpandCollapse-module--expandTitleFullWidth--Y88YA";
export var expandTitleRight = "ExpandCollapse-module--expandTitleRight--NzzND";
export var isExpandCollapse = "ExpandCollapse-module--isExpandCollapse--BjRzD";
export var isExpandCollapseIcon = "ExpandCollapse-module--isExpandCollapseIcon--mg5bE";
export var isExpanded = "ExpandCollapse-module--isExpanded--ke5rv";
export var isExpandedIcon = "ExpandCollapse-module--isExpandedIcon--cOoDN";
export var limitWidthOnLargeScreens = "ExpandCollapse-module--limitWidthOnLargeScreens--HuEqS";
export var plusIcon = "ExpandCollapse-module--plusIcon--Z4wnB";